"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailInput = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _constants = require("../../../../../../constants");
var _NewsletterDialogContext = require("../NewsletterDialogContext");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const EmailInput = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    register
  } = (0, _reactHookForm.useFormContext)();
  const {
    errors
  } = (0, _reactHookForm.useFormState)({
    name: 'email'
  });
  const {
    content
  } = (0, _NewsletterDialogContext.useNewsletterDialogContext)();
  const email = (0, _reactHookForm.useWatch)({
    name: 'email'
  });
  const endAdornment = (0, _react.useMemo)(() => {
    if (!email) {
      return null;
    }
    const iconType = errors.email ? 'error' : 'success';
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.InputAdornment, {
      position: "end",
      children: _constants2.adornmentIcons[iconType]
    });
  }, [email, errors.email]);
  const inputProps = (0, _react.useMemo)(() => ({
    endAdornment,
    [_constants.DATA_TEST_ID]: getTestId(_constants2.EMAIL_INPUT)
  }), [endAdornment, getTestId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
    ...register('email', {
      setValueAs: value => value.trim()
    }),
    autoFocus: true,
    fullWidth: true,
    required: true,
    value: email,
    id: "e-mail",
    error: !!errors.email,
    helperText: errors.email?.message,
    label: content.emailLabel,
    type: "email",
    InputProps: inputProps
  });
};
exports.EmailInput = EmailInput;
